<template>
    <div id="404-page">
        <h1 class="">Pagina niet gevonden.</h1>
        <hr />
        <p>Misschien zit er een typfout in de url? Via onze zoekfunctie rechts bovenin de navigatie vind je hopelijk snel de juiste pagina. Als je denkt dat hier toch een pagina had moeten staan, neem dan alsjeblieft contact met ons op.</p>
    </div>
</template>

<script>
export default{
    name: 'NotFound',
    metaInfo: function() {
        return {
            title: "Yoursource" + " - pagina niet gevonden.",
            meta: [
                {
                    name: 'description', content: "uw partner op het gebied van bedrijfsadvisering en automatisering.",
                },
                {
                    name: 'keywords', content: "Yoursource, Exact, Software, Orbis, Crm, Hrm, Microsoft"
                }
            ]
        }
    },
}
</script>
